import { render, staticRenderFns } from "./HealthListEmpty.vue?vue&type=template&id=cfda5b2c&scoped=true&"
import script from "./HealthListEmpty.vue?vue&type=script&lang=js&"
export * from "./HealthListEmpty.vue?vue&type=script&lang=js&"
import style0 from "./HealthListEmpty.vue?vue&type=style&index=0&id=cfda5b2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfda5b2c",
  null
  
)

export default component.exports